import AppHeader from "../../layout/AppHeader";
import Message from '../../xpost/views/services/message/Message.vue';
import MessageAdd from '../../xpost/views/services/message/MessageAdd.vue';
import NotificationTemplate from '../../xpost/views/comum/notification/template/NotificationTemplate';
import NotificationTemplateAdd from '../../xpost/views/comum/notification/template/NotificationTemplateAdd';

const MessageRoutes = [
  {
    path: "/servicos/mensagem",
    name: "message",
    components: {
      header: AppHeader,
      default: Message,
    }
  },
  {
    path: "/servicos/mensagem/adicionar",
    name: "message.add",
    components: {
      header: AppHeader,
      default: MessageAdd,
    }
  },
  {
    path: "/cadastro/template",
    name: "notification.template",
    components: {
      header: AppHeader,
      default: NotificationTemplate,
    }
  },
  {
    path: "/cadastro/template/adicionar",
    name: "notification.template.add",
    components: {
      header: AppHeader,
      default: NotificationTemplateAdd,
    }
  },
]

export default MessageRoutes;